import Vue from 'vue';
import { Alert, Toast, Confirm, Loading } from 'vue-dialog-simple';

Vue.use(Loading);
Vue.use(Toast);
Vue.use(Confirm);
Vue.use(Alert);
